<template>
  <div class="vuse-content-wrapper">
    <div v-if="hasAccess('client')">
    <vuse-section-definition
      :title="page"
      icon="mdi-card-account-details"
    ></vuse-section-definition>
    <v-container fluid class="">
      <v-row>
        <v-col cols="12" lg="3" md="3" sm="4">
          <v-text-field
            v-model="filter.SearchTerm"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            solo
            hide-details
          ></v-text-field>
        </v-col>
        <v-col cols="12" lg="3" md="3" sm="4">
          <v-select
            auto-select-first
            clearable
            :items="isBusinessOptions"
            v-model="filter.isBusiness"
            label="Filter by Account Type"
            item-text="text"
            item-value="value"
            :return-object="false"
            single-line
            solo
            hide-details
          />
        </v-col>
        <v-col cols="12" lg="3" md="3" sm="4">
          <v-select
            auto-select-first
            clearable
            :items="isPotentialOptions"
            v-model="filter.isPotential"
            label="Filter by Potential Client"
            item-text="text"
            item-value="value"
            :return-object="false"
            single-line
            solo
            hide-details
          />
        </v-col>
        <v-col cols="12" lg="3" md="3" sm="12" class="text-right">
          <v-btn
            color="info"
            dark
            class="mb-2"
            @click="newClient()"
            v-show="hasAccess('client.add')"
          >
            Add Client
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
        <v-card>
          <v-skeleton-loader
            v-if="isLoading"
            class="mx-auto"
            type="table"
          ></v-skeleton-loader>
          <v-data-table
            v-else
            :headers="activeHeaders"
            :loading="loading"
            :items="dataItems"
            class="elevation-1"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50, 100, 200] }"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn rounded class="content-ma-0 mr-2" v-on="on" x-small>
                      <v-icon small>menu</v-icon> Customize Columns
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item dense :key="i" v-for="(header, i) in headers">
                      <v-list-item-title v-if="header.readonly">
                        <v-checkbox
                          v-model="headers[i].active"
                          :label="header.text"
                          :disabled="true"
                        />
                      </v-list-item-title>
                      <v-list-item-title v-else>
                        <v-checkbox
                          v-model="headers[i].active"
                          :label="header.text"
                        />
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
            </template>

            <template v-slot:item.lastUpdated="{ item }">
              <v-chip @click="onEdit(item)" small>
                {{ item.lastUpdated | formatDatetime }}
              </v-chip>
            </template>

            <template v-slot:item.companyName="{ item }">
              <router-link
                :to="{ path: 'clients/' + item.id }"
                class="text-decoration-none"
              >
                {{ item.companyName }}
              </router-link>
            </template>

            <template v-slot:item.client="{ item }">
              <span @click="viewItem(item)"
                >{{ item.firstName }} {{ item.lastName }}</span
              >
            </template>

            <template v-slot:item.phoneNumber="{ item }">
              <a
                :href="`tel:${item.phoneNumber}`"
                :alt="`${item.phoneNumber}`"
                >{{ item.phoneNumber }}</a
              >
            </template>
          </v-data-table>
        </v-card>
        </v-col>
      </v-row>
    </v-container>

    <delete-dialog
      :item="selectedItem"
      :show="showDelete"
      @onSucceded="refresh()"
      @onClosed="clearDelete()"
    />
    </div>
    <NoPermission v-else />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import DeleteDialog from "./Client/_Delete";
import formatterMixin from "@/mixins/formatterMixin";
import _ from "lodash";
import { getStorage, setStorage } from "src/utils/helpers";
import NoPermission from "components/NoPermission";

const SETTING_LIST_KEY = "client-columns";
const defaultHeaders = [
  { text: "Company", value: "companyName", active: true },
  {
    text: "Clients",
    align: "start",
    sortable: false,
    value: "client",
    active: true,
  },
  { text: "Mobile", value: "phoneNumber", active: true },
  { text: "Email", value: "email", active: true },
  {
    text: "Date Modified",
    value: "lastUpdated",
    sortable: true,
    active: false,
  },
];

export default {
  mixins: [formatterMixin],
  components: {
    DeleteDialog,
    NoPermission
  },
  data: () => ({
    loading: false,
    options: {},
    filter: {
      isBusiness: null,
      isPotential: null,
      SearchTerm: "",
    },
    isBusinessOptions: [
      { text: "Show All", value: null },
      { text: "Business Account", value: true },
      { text: "Personal Account", value: false },
    ],
    isPotentialOptions: [
      { text: "Show All", value: null },
      { text: "Potential", value: true },
      { text: "Not Potential", value: false },
    ],
    isEdit: false,
    valid: false,
    namespace: "Clients",
    page: "Clients",
    usage: "usage",
    keyword: "",
    headers: defaultHeaders.map((item) => {
      let savedHeaders = getStorage(SETTING_LIST_KEY) || [];
      let nowHeader = savedHeaders.filter(
        (saved) => saved.value === item.value
      );

      if (nowHeader) {
        nowHeader = nowHeader[0];
      }
      return {
        ...item,
        ...nowHeader,
      };
    }),
    showDelete: false,
    selectedItem: {},
    clients: [],
  }),
  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      totalItems: (state) => state.client.metaData.totalEntries
    }),    
    isLoading() {
      return this.loading && this.dataItems.length == 0;
    },
    dataItems() {
      return this.$store.getters["client/getAll"];
    },
    activeHeaders() {
      return this.headers.filter((header) => header.active);
    },
  },
  watch: {
    headers: {
      handler() {
        setStorage(SETTING_LIST_KEY, this.headers);
      },
      deep: true,
    },

    options: {
      handler(n, o) {
        if (JSON.stringify(n) !== JSON.stringify(o)) {
          this.doFilter();
        }
      },
      deep: true,
    },
    filter: {
      handler() {
        this.doFilter();
      },
      deep: true,
    },
  },

  beforeDestroy() {
    this.$store.dispatch("client/clearFilter");
    this.$store.dispatch("client/clearData");
  },

  async mounted() {
    this.doFilter();
  },

  methods: {
    ...mapActions("client", ["getAll", "search"]),

    newClient() {
      this.$router.push({
        path: "/clients/create",
      });
    },

    viewItem(item) {
      this.$router.push(`/clients/${item.id}`);
    },

    onDelete(item) {
      this.showDelete = true;
      this.selectedItem = item;
    },

    clearDelete() {
      this.showDelete = false;
      this.selectedItem = {};
    },

    refresh() {
      this.doFilter();
    },

    doFilter: _.debounce(async function () {
      let { SearchTerm, isBusiness, isPotential } = this.filter;
      let { sortBy, sortDesc, page, itemsPerPage } = this.options;
      let params = {
        PageNumber: page ? page : 1,
        PageSize: itemsPerPage > 0 ? itemsPerPage : this.totalItems,
      };

      if (SearchTerm) {
        params.SearchTerm = SearchTerm;
      }

      if (isBusiness === true || isBusiness === false) {
        params.isBusiness = isBusiness;
      }

      if (isPotential === true || isPotential === false) {
        params.isPotential = isPotential;
      }

      if (sortBy.length > 0 && sortDesc.length > 0) {
        params.OrderBy = sortBy[0];
        params.Ascending = sortDesc[0] ? false : true;
      }
      this.loading = true;
      await this.getAll(params);
      this.loading = false;
    }, 500),
  },
};
</script>
